export default __webpack_public_path__ + "static/media/museosans-300.2eac246c.ttf";